module.exports = __webpack_public_path__ + "assets/images/premium-features/unavailabilityApproval-c9acb8.png";